import { useToast } from "vue-toastification";

import Router from "@/router/appRouter.js";
import { i18n } from "@/i18n";

const { t, te } = i18n.global;

function getError(error_code, params) {
  return te(`other.error.${error_code}`, params) ? t(`other.error.${error_code}`, params) : t("other.error.ERROR_UNKNOWN");
}

function traduceAccessError(error) {
  if (![401, 410].includes(error.code)) return;

  const toast = useToast();

  const logoutError = [
    "ERROR_AUTH_INVALID_TOKEN",
    "COMPANY_PERMISSION_DENIED",
    "ERROR_AUTH_MISSING_TOKEN",
  ];

  if (error.key === "ERROR_PERMISSIONS_FORBIDDEN_ACTION") {
    toast.info(getError("ERROR_PERMISSIONS_FORBIDDEN"));
    Router.push({ name: "root" });
  }
}

function catchError(error) {
  if (error.response) return error.response.data;

  const toast = useToast();

  toast.error(getError("ERROR_UNKNOWN"));

  throw error;
}

export { getError, traduceAccessError, catchError };
